import FiscaliteScreen, { fmt, fetchAllPaginated } from './FiscaliteScreen';
import { frenchDate } from '../../../variables/functions';

// Retenues sur commissions à reverser : commissions versées aux intermédiaires (courtier/agence)
// dans le mois, avec la retenue fiscale (commission × tauxRetenue) en exergue + récap par bénéficiaire.
const num = (n) => Number(n) || 0;
const retenueOf = (r) => num(r.commission) * num(r.tauxRetenue) / 100;

const RetenuesCommissions = () => {
    const fetchRows = (start, end, compagnie) =>
        fetchAllPaginated('/api/reglement/avec-commission', { startDate: start, endDate: end, compagnie: compagnie || undefined });

    const columns = [
        {
            title: 'Bénéficiaire', key: 'benef',
            render: (_, r) => (
                <div>
                    <div style={{ fontWeight: 600 }}>{r.beneficiaireNom || '—'}</div>
                    {r.beneficiaireType && <div style={{ fontSize: 11, color: '#9ca3af' }}>{r.beneficiaireType}</div>}
                </div>
            ),
        },
        { title: 'N° Police', key: 'police', render: (_, r) => r.numeroPolice || r.police || '—' },
        { title: 'Date règlement', dataIndex: 'dateReglement', render: (v) => v ? frenchDate(v) : '—' },
        { title: 'Commission (FCFA)', dataIndex: 'commission', align: 'right', render: (v) => fmt(v) },
        { title: 'Taux retenue', dataIndex: 'tauxRetenue', align: 'right', render: (v) => (v != null ? `${v}%` : '—') },
        {
            title: 'Retenue (FCFA)', key: 'retenue', align: 'right',
            render: (_, r) => <b style={{ color: '#242166', fontVariantNumeric: 'tabular-nums' }}>{fmt(retenueOf(r))}</b>,
            sorter: (a, b) => retenueOf(a) - retenueOf(b),
        },
    ];

    const kpis = (rows) => [
        { label: 'Commissions', value: rows.length },
        { label: 'Commissions versées', value: rows.reduce((a, r) => a + num(r.commission), 0), money: true },
        { label: 'Retenues à reverser', value: rows.reduce((a, r) => a + retenueOf(r), 0), money: true, highlight: true, sub: 'à reverser à l\'État' },
    ];

    const recapParBeneficiaire = (rows) => {
        const map = new Map();
        rows.forEach((r) => {
            const key = r.beneficiaireNom || '—';
            const g = map.get(key) || { label: key, count: 0, total: 0 };
            g.count += 1;
            g.total += retenueOf(r);
            map.set(key, g);
        });
        return Array.from(map.values()).sort((a, b) => b.total - a.total);
    };

    // Regroupement par taux d'impôt (tauxRetenue explicite du bénéficiaire).
    const recapParTaux = (rows) => {
        const map = new Map();
        rows.forEach((r) => {
            const key = r.tauxRetenue != null ? `${r.tauxRetenue}%` : '—';
            const g = map.get(key) || { label: key, count: 0, total: 0 };
            g.count += 1;
            g.total += retenueOf(r);
            map.set(key, g);
        });
        return Array.from(map.values()).sort((a, b) => b.total - a.total);
    };

    const groupRecaps = [
        { title: 'Récapitulatif par taux d\'impôt', labelHeader: 'Taux d\'impôt', compute: recapParTaux },
        { title: 'Récapitulatif par bénéficiaire', labelHeader: 'Bénéficiaire', compute: recapParBeneficiaire },
    ];

    const exportColumns = [
        { header: 'Bénéficiaire', accessor: (r) => r.beneficiaireNom || '' },
        { header: 'Type', accessor: (r) => r.beneficiaireType || '' },
        { header: 'N° Police', accessor: (r) => r.numeroPolice || r.police || '' },
        { header: 'Date règlement', accessor: (r) => (r.dateReglement ? frenchDate(r.dateReglement) : '') },
        { header: 'Commission (FCFA)', accessor: (r) => num(r.commission), money: true },
        { header: 'Taux retenue (%)', accessor: (r) => (r.tauxRetenue != null ? r.tauxRetenue : '') },
        { header: 'Retenue (FCFA)', accessor: (r) => retenueOf(r), money: true },
    ];

    return (
        <FiscaliteScreen
            title="Retenues sur commissions à reverser"
            subtitle="Retenues fiscales sur les commissions versées aux intermédiaires dans le mois"
            fetchRows={fetchRows}
            kpis={kpis}
            columns={columns}
            exportColumns={exportColumns}
            groupRecaps={groupRecaps}
            pdfTitle="RETENUES SUR COMMISSIONS À REVERSER"
            fileBase="Retenues_commissions"
        />
    );
};

export default RetenuesCommissions;
